import { FastLayer, Circle, Group, Stage, Layer, Rect, Line} from 'react-konva';
import AutomationPoint from './AutomationPoint.js';
import {setAutomationGuidePoint} from 'actions/index.js';
import { connect } from "react-redux";
import React, {useReducer, memo, useState, useCallback, useEffect} from 'react';
import {
    getStepFromXPosition,
    getValueFromYPosition,
    getYForParameter} from './position.js';
import {getLinePoints} from './getLinePoints.js';
import Colors from 'components/Colors.js';
const colors = new Colors();

window.otherColor = '#637475';

const AllLinePoints = memo(({
    automation,
    track,
    sequencerEngine,
    pointHovered, 
    pointsSelected,
    pointDragging,
    xScale,
    color,
    isMix,
    height,
    selectedParameter,
    setGuidePoint,
    width}) => {
        let parametersWithAutomations = track.getAllParameters()
            .filter(x => x.automations.length > 0)
            .filter(param => param !== selectedParameter);

        parametersWithAutomations = parametersWithAutomations.slice(0, 4);

        let allLinePoints = parametersWithAutomations.map(
            parameter => getLinePoints({
                width,
                height,
                selectedParameter: parameter,
                xScale,
                events: isMix ? parameter.mixAutomation.automations : parameter.automations
            }));

        return allLinePoints.map(
                (pts, i) => 
                    <polyline
                      key={"line-" + i}
                      strokeWidth={1}
                      points={pts.join(",")}
                      stroke={colors.brighten(color, 0.6)}/>

        );
    });


export default connect(null, null)(AllLinePoints);



